/**
 * 上传进度对话框组件
 * 从 MainPage.tsx 提取，用于减少主文件大小
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  LinearProgress
} from '@mui/material';

interface UploadProgressDialogProps {
  open: boolean;
  fileName: string | null;
  progress: number;
}

const UploadProgressDialog: React.FC<UploadProgressDialogProps> = ({
  open,
  fileName,
  progress
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        ☁️ 檔案上傳中
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            正在上傳：<strong>{fileName}</strong>
          </Typography>
          
          <Box sx={{ mt: 3, mb: 2 }}>
            <LinearProgress 
              variant="determinate" 
              value={progress} 
              sx={{ height: 8, borderRadius: 4 }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {progress}%
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            請勿關閉頁面，上傳完成後將自動進入檔案總管
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UploadProgressDialog;

